(ns minorodata.json-flattening.events
  (:require [minorodata.app.handlers :refer [reg-event-fx]]))


(reg-event-fx
 :json-flattening.events/create-transform
 (fn [_ [{:keys [group-id transform on-success]}]]
   {:async-flow
    {:first-dispatch [:transform.api/parse-sql-v2 {:sql (:command transform)}]
     :rules [{:when :seen?
              :events [:transform.api/parse-sql-v2-success]
              :halt? true
              :dispatch-fn (fn [[_ _ _ resp]]
                             [[:environments.api/create-transform
                               {:group-id   group-id
                                :transform  (merge {:input-tables (get-in resp [:results :input-tables])
                                                    :output-tables (get-in resp [:results :output-tables])}
                                                   transform)
                                :on-success on-success}]])}
             {:when :seen?
              :events [:transform.api/parse-sql-v2-failure]
              :halt? true}]}}))
